import { Trans } from '@lingui/react/macro';
import { LinearProgress } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { VideaTypography } from '../../common-components/elements/VideaTypography/VideaTypography';
import { blueBlack630 } from '../../theme/videa-style-tokens';

import { LoadingErrorContainer } from './ExternalUrlHandler';

export const LoadingMagicLink = () => {
  const location = useLocation();
  const isExternalVisitSidebar = location.hash.includes(
    'external-visit-sidebar',
  );
  const isExternalModal = location.hash.includes('external-modal');

  if (isExternalVisitSidebar || isExternalModal) {
    return (
      <LoadingErrorContainer>
        <div className="message-container">
          <VideaTypography variant="headingMedium" color={blueBlack630}>
            <Trans>Loading. Please wait.</Trans>
          </VideaTypography>
          <LinearProgress />
        </div>
      </LoadingErrorContainer>
    );
  }
  return (
    <LoadingErrorContainer>
      <div className="message-container">
        <VideaTypography variant="headingMedium" color={blueBlack630}>
          <Trans>Your patient is loading. Please wait.</Trans>
        </VideaTypography>
        <LinearProgress />
      </div>
    </LoadingErrorContainer>
  );
};
